import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { useFragment } from "react-relay";
import { TextElementPart_ContentSubmissionFragment$key } from "@generated/TextElementPart_ContentSubmissionFragment.graphql";
import { TextElementDisplay } from "./TextElementDisplay.component";
import { ProjectContentElementContainer } from "../../../../infecto-lms-webapp-impl/containers/ProjectContentElement.container";
import { isWissenwirktApp } from "../../../utils/isWissenwirktApp";
import { SubmitDisplayElementButton } from "../SubmitDisplayElementButton.component";

const CONTENT_SUBMISSION_FRAGMENT = graphql`
	fragment TextElementPart_ContentSubmissionFragment on ContentSubmission {
		id
		definition {
			... on ActiveELearningContentSubmissionDefinition {
				currentElementState {
					element {
						...TextElementDisplay_TextElementV2Fragment
					}
				}
			}
		}
		...ContentElementContainer_ContentSubmissionFragment
		...SubmitDisplayElementButton_ContentSubmissionFragment
		...ProjectContentElementContainer_ContentSubmissionFragment
	}
`;

interface OwnProps {
	contentSubmissionFragmentRef: TextElementPart_ContentSubmissionFragment$key;
}

export function TextElementPart({ contentSubmissionFragmentRef }: OwnProps) {
	const contentSubmission = useFragment<TextElementPart_ContentSubmissionFragment$key>(
		CONTENT_SUBMISSION_FRAGMENT,
		contentSubmissionFragmentRef,
	);

	if (!contentSubmission.definition.currentElementState) return null;

	return (
		<ProjectContentElementContainer
			contentSubmissionFragmentRef={contentSubmission}
			nextButton={<SubmitDisplayElementButton contentSubmissionFragmentRef={contentSubmission} />}
		>
			<TextElementDisplay
				isShowingTitle={!isWissenwirktApp}
				textElementFragmentRef={contentSubmission.definition.currentElementState.element}
			/>
		</ProjectContentElementContainer>
	);
}
